/**
 * This is a "light" version of @exodus/core resolution to select the native WebSocket on BE
 * It's a workaround until https://github.com/ExodusMovement/assets/pull/72 is merged.
 *
 * Based on https://github.com/ExodusMovement/fetch/blob/master/core.js , note that chooses native on Desktop
 */
if (typeof process !== 'undefined' && (process.type === 'renderer' || process.type === 'worker')) {
  // THIS IS FOR DESKTOP
  if (process.env.EXODUS_DISABLE_WS) {
    module.exports = globalThis.WebSocket
  } else {
    module.exports = require('ws')
  }
  // eslint-disable-next-line no-undef
} else if (typeof WebSocket === 'undefined') {
  // THIS IS FOR UNIT TESTING.
  module.exports = require('ws')
} else {
  // THIS IS FOR BE
  module.exports = globalThis.WebSocket
}
